module.exports = "<app-authorised-top-nav></app-authorised-top-nav>\n<div class=\"wrapper\">\n    <app-authorised-side-nav></app-authorised-side-nav>\n\n    <app-page-content></app-page-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-layout/authorised-layout.component.html
// module id = ../../../../../src/app/layout/authorised/authorised-layout/authorised-layout.component.html
// module chunks = main